<ngb-toast
  *ngFor="let toast of toasts"
  class="toast-wrapper"
  [autohide]="true"
  [delay]="toast.delay || 3000"
  (hidden)="remove(toast)"
>
  <div class="toast-base" [class]="'toast-' + toast.type?.toLowerCase()">
    <div class="toast-icon">
      <ng-container *ngIf="toast.type === 'success'"
        ><i class="fas fa-check-circle"></i
      ></ng-container>
      <ng-container *ngIf="toast.type === 'error'"
        ><i class="fas fa-exclamation-circle"></i
      ></ng-container>
      <ng-container *ngIf="toast.type === 'warning'"
        ><i class="fas fa-exclamation-triangle"></i
      ></ng-container>
      <ng-container *ngIf="toast.type === 'info'"
        ><i class="fas fa-info-circle"></i
      ></ng-container>
    </div>
    <div class="toast-content-wrapper">
      <div class="toast-title" *ngIf="toast.title">{{ toast.title }}</div>
      <div class="toast-content">{{ toast.content }}</div>
    </div>
    <div class="toast-close">&times;</div>
  </div>
</ngb-toast>
